export const LOCALE_LOCALIZATION_KEYS_MAP = new Map<string, string>([
    ['en-us', 'aumico_users_edit_user_general_information_languages_english_us'],
    ['de-ch', 'aumico_users_edit_user_general_information_languages_german_switzerland'],
    ['de-de', 'aumico_users_edit_user_general_information_languages_german_germany'],
    ['it-ch', 'aumico_users_edit_user_general_information_languages_italian_switzerland'],
    ['fr-ch', 'aumico_users_edit_user_general_information_languages_french_switzerland'],
]);
